/**
Project: Voice Panel (c)
Title: Domain Setup Reducer
Description: Reducer for the domain setup
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import {
  DOMAIN_SETUP_PROGRESS_PAGE,
  DOMAIN_SETUP_PROGRESS_ACCOUNT_ID,
  DOMAIN_SETUP_PROGRESS_DOMAIN_REGIONS,
  DOMAIN_SETUP_PROCESS_DOMAIN_RECORD,
  DOMAIN_SETUP_PROCESS_UPDATE_DOMAIN_RECORD,
  DOMAIN_CREATE_USERS,
  DOMAIN_SETUP,
} from "./constants";

const INIT_STATE = {
  domainSetupProgressPage: 0,
  domainSetupProgressAccountNumber: null,
  domainSetup: {},
  domainRegions: [],
  domainDnsRecord: [],
  domainUsers: []
};

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DOMAIN_SETUP_PROGRESS_PAGE:
      return {
        ...state,
        domainSetupProgressPage: action.payload,
      };
    case DOMAIN_SETUP_PROGRESS_ACCOUNT_ID:
      return {
        ...state,
        domainSetupProgressAccountNumber: action.payload,
      };
    case DOMAIN_SETUP:
      return {
        ...state,
        domainSetup: action.payload,
      };
    case DOMAIN_SETUP_PROGRESS_DOMAIN_REGIONS:
      return {
        ...state,
        domainRegions: action.payload,
      };
    case DOMAIN_SETUP_PROCESS_DOMAIN_RECORD:
      return {
        ...state,
        domainDnsRecord: action.payload
      };
    case DOMAIN_SETUP_PROCESS_UPDATE_DOMAIN_RECORD:
      return {
        ...state,
        domainDnsRecord: state.domainDnsRecord.map((domain) => {
          if (domain.domainName === action.payload.domainName) {
            return Object.assign({}, domain, {
              textRecord: action.payload.textRecord,
            });
          }
          return Object.assign({}, domain, {});
        }),
      };
    case DOMAIN_CREATE_USERS:
      return {
        ...state,
        domainUsers: action.payload
      };
    default:
      return state;
  }
};